import type { GetDocumentAssessmentResultByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDocumentAssessmentResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDocumentAssessmentResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetDocumentAssessmentResultByIdArgs = {
  id: string;
};

export const useGetDocumentAssessmentResultById = createQueryHook<
  UseGetDocumentAssessmentResultByIdArgs,
  GetDocumentAssessmentResultByIdResponseRow[],
  GetDocumentAssessmentResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.documentAssessmentResult.documentAssessmentResultById.queryOptions(
      { id }
    ),
  mapTrpcDataToGraphQL: (data) => ({ document_assessment_result: data }),
  graphqlDocument: GetDocumentAssessmentResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
